export const payrollPersonHistoryType = {
  ADD_PERSON_PAYROLL_HISTORY: 'ADD_PERSON_PAYROLL_HISTORY',
  REMOVE_PERSON_PAYROLL_HISTORY: 'REMOVE_PERSON_PAYROLL_HISTORY',
  RESET_ENTIRE_STATE: 'RESET_ENTIRE_STATE',
  FETCH_PAYROLL_REQUEST: 'FETCH_PAYROLL_REQUEST',
  FETCH_PAYROLL_SUCCESS: 'FETCH_PAYROLL_SUCCESS',
  FETCH_PAYROLL_FAILURE: 'FETCH_PAYROLL_FAILURE'
};
